<template>
    <div>
        <ValidationObserver ref="formModalValidate">
            <b-row class="m-3">
                <b-col cols="12">
                    <div>
                        <p class="font-weight-bold">E. Time-Off and Transferring Out</p>
                    </div>
                    <div>
                        <p>
                            This policy outlines guidelines for taking time off while maintaining F1 status
                            It ensures that students comply with federal and school regulations regarding enrollment and authorized breaks,
                            balancing academic responsibilities with personal needs.
                        </p>
                    </div>
                </b-col>
                <b-col cols="12">
                    <div>
                        <p><strong>Time Off Eligibility</strong></p>
                        <p>
                            To comply with U.S. SEVIS regulations, F-1 students are eligible to take up to one full session (three modules) of authorized Time Off per calendar year (12 months). Due to Mentora ESL course models and SEVIS regulations, students are not permitted to take Time Off in the middle of a session. Students should also note that Time Off is NOT cumulative.
                        </p>
                        <p><strong>1. First Time Off Period</strong></p>
                        <p>
                            F-1 students become eligible for their first Time Off period after successfully completing six (6) consecutive academic modules, equivalent to two (2) full academic sessions. Once eligible, Time Off must be taken in the next immediately consecutive module or session, and students may choose one of the following options:
                        </p>
                        <ul>
                            <li>Take one (1) module of Time Off, which must be Module 1 of the next session, or</li>
                            <li>Take one full session (three consecutive modules) of Time Off, beginning with Module 1 of the next session.</li>
                        </ul>
                        <p>
                            Students may not complete one or more modules of a session and then begin Time Off later within that same session.
                        </p>

                        <p><strong>2. Subsequent Time Off Periods</strong></p>
                        <p>
                            After returning from their first approved Time Off period, students may become eligible for additional Time Off after completing the required three (3) or six (6) consecutive study modules, as applicable. Time Off must be taken in the next immediately consecutive module or session, and students may choose one of the following options:
                        </p>
                        <ul>
                            <li>Take one (1) module of Time Off, after completing three (3) consecutive study modules. The Time Off must be taken as Module 1 of the next session, or</li>
                            <li>Take one full session (three consecutive modules) of Time Off, after completing six (6) consecutive study modules. The Time Off must begin with Module 1 of the next session.</li>
                        </ul>
                        <p>
                            All Time Off periods remain subject to a maximum of three (3) Time Off modules within any 12-month period.
                        </p>

                        <p><strong>Student Standing Requirement</strong></p>
                        <p>To be eligible for Time Off, students must be in good standing, which includes:</p>
                        <ul>
                            <li>Good academic standing</li>
                            <li>Good attendance</li>
                            <li>Good financial standing</li>
                        </ul>

                        <p><strong>Important Notes</strong></p>
                        <ul>
                            <li>Time Off eligibility is based on continuous enrollment and successful academic progress.</li>
                            <li>All Time Off requests are subject to administrative review and approval.</li>
                            <li>Students are encouraged to plan their Time Off periods carefully to maintain F-1 status compliance.</li>
                            <li>For the purposes of this policy, “consecutive modules” refer to modules completed in uninterrupted academic sessions, excluding any module during which the student was on a medically excused absence or had an approved reduced course load.</li>
                        </ul>

                        <p><strong>Deadlines for Time Off request.</strong></p>
                        <p>
                            All students must submit all required documents for Time Off before the deadline of the current class module they are attending (See Handbook Section 5).
                        </p>

                        <p><strong>Time-Off Fee</strong></p>
                        <p>
                            The Time-Off Fee is calculated as 50% of the tuition for each module taken as Time Off, plus the tuition deposit for one (1) module, which must be paid in advance.
                            The deposit will be credited toward tuition when the student returns from their approved Time Off period.
                        </p>
                    </div>
                </b-col>
                <b-col cols="12">
                    <p>
                        <strong>Transferring Out (F-1 Students)</strong>
                    </p>
                    <p>
                        As an F-1 student, you may transfer to another institution
                        in the U.S. if you wish to continue your studies at a different institution.
                        However, there are specific eligibility requirements and procedures that must be followed to ensure your transfer is compliant with both school and federal regulations. This section outlines the steps you need to take.

                    </p>
                </b-col>



                <b-col cols="12">
                    <p>
                        <strong>Required documents</strong>
                    </p>
                    <p>
                        Students requesting a Transfer Out must submit their request through their MyBAU student account by completing the Transfer Out Request section. Students are required to complete all requested personal information and upload the required supporting documentation directly within the system:
                    </p>
                    <ul>
                        <li>A completed Transfer Out Request submitted through MyBAU</li>
                        <li>An official acceptance letter from the new institution</li>
                        <li>A Transfer Out Verification Form from the new institution (if applicable)</li>
                    </ul>
                    <p>
                        All required documents must be uploaded at the time of submission. Incomplete or late submissions may delay processing and may be subject to a Late Document Processing Fee. For more information, see the Deadline for Transferring Out section.
                    </p>
                </b-col>
                <b-col cols="12">
                    <p><strong>Deadlines for Transferring out.</strong></p>
                    <p>
                        All students must submit all required documents for Transferring out before the deadline of the current class module they are attending (See Handbook Section 5).
                    </p>
                    <p>
                        No exceptions will be made. If a student misses the deadline the student is required to:
                    </p>
                    <ul>
                        <li>Register and complete one additional class module or</li>
                        <li>Complete a “Late Document Processing Fee” equal to $640.</li>
                    </ul>
                    <p>
                        This Late Document Processing Fee may apply to all students who submit required documents or complete administrative processes after the stated deadlines. This fee accounts for the additional time and resources required to manually handle and reconcile late submissions outside of the standard processing timeline. Timely compliance with deadlines helps the university serve all students more efficiently and fairly.
                    </p>

                    <p><strong>Transferring out before completing first session (first 3 modules)</strong></p>
                    <p>
                        All new students must study their first session (first 3 modules) to be eligible to transfer out. If a student is willing to transfer before completing their first session the student must complete all transfer out documents and pay the “Administrative Services Fee”. This fee reflects the administrative time and resources required to process early withdrawals, including coordination with internal departments and external institutions. Completing at least one full session ensures smoother transitions and helps maintain the integrity of academic and administrative planning.
                    </p>

                    <p><strong>Transferring out after Time off.</strong></p>
                    <p>
                        All students who return from time off must register and complete one full session (3 modules) before they are eligible to transfer in active status to another institution. If a student decides not to register or to withdraw before completing all 3 modules, they must pay an “Administrative Services Fee”, complete all required documents and follow all transfer out steps. This fee reflects the administrative time and resources required to process early withdrawals, including coordination with internal departments and external institutions. Completing at least one full session ensures smoother transitions and helps maintain the integrity of academic and administrative planning.
                    </p>
                    <p>
                        To be eligible to transfer to another institution, you must meet the following requirements:
                    </p>
                    <ol>
                        <li>
                            Complete your initial session (first 3 modules) in the Mentora College ESL Program.
                        </li>
                        <li>
                            Be in good standing, which means you must have:
                            <ul>
                                <li>Good Academic Standing</li>
                                <li>Good Attendance</li>
                                <li>Good Financial Standing</li>
                                <li>No types of probation</li>
                            </ul>
                        </li>
                        <li>
                            Not be in a Time Off period (you must be actively enrolled in classes).
                        </li>
                        <li>
                            Maintain your F-1 status (If applicable):
                            <ul>
                                <li>You must follow all school and federal regulations.</li>
                                <li>You must continue attending classes until your transfer release date.</li>
                                <li>If you don’t maintain your F-1 status or fail to follow proper procedures, you may lose eligibility to transfer in Active status.</li>
                            </ul>
                        </li>
                    </ol>
                    <p>
                        If the student wishes to transfer their SEVIS record to another institution prior to completing a session (3 Modules) after Time-Off, BAU Mentora ESL Program will not refund any portion of their tuition deposit or fees and the student will be required to pay an Administrative Service Fee.
                        (See section 5.2.1 to 5.2.5 of the Mentora ESL Handbook for detailed information).
                    </p>
                </b-col>



                <b-col cols="12" class="mt-3">
                    <b-row class="d-flex align-items-center flex-column flex-md-row  justify-content-md-between">
                        <b-col cols="12" md="8" class="mb-2 mb-md-0 d-flex flex-row-md-reverse flex-row">
                            <ValidationProvider
                                name="status"
                                rules="required"
                                v-slot="{ valid, errors }"
                            >
                                <div class="d-flex flex-row-reverse">
                                    <b-form-checkbox
                                        id="checkbox-1"
                                        v-model="form.status"
                                        name="checkbox-1"
                                        value="accepted"
                                        :unchecked-value="null"
                                        class="text-sm text-md-md ml-4"
                                    >
                                    </b-form-checkbox
                                    >

                                    <div>
                                        I read and confirm that I understand the information in Section E.                                     </div>
                                </div>
                                <b-form-invalid-feedback v-if="errors[0]">
                                    {{ errors[0] }}
                                </b-form-invalid-feedback>
                            </ValidationProvider>
                        </b-col>
                        <b-col cols="12" md="4" class="text-md-right mt-3">
                            <b-button
                                type="submit"
                                @click="next"
                                variant="primary"
                                class="w-100 w-md-auto"
                            >
                                {{ $t('next') }}
                            </b-button>
                        </b-col>
                    </b-row>
                </b-col>
            </b-row>
        </ValidationObserver>
    </div>
</template><script>
export default {
    data() {
        return {
            form: {},
            fallSpringData: [
                { key: "Before the semester starts", value: "100%" },
                { key: "1st and 2nd Week of the Semester", value: "50%" },
                { key: "3rd and 4th Weeks of the Semester", value: "25%" },
                { key: "After 4th week", value: "No refund" }
            ],
            summerData: [
                { key: "Before the semester starts", value: "100%" },
                { key: "1st Week of the Semester", value: "50%" },
                { key: "2nd Week of the Semester", value: "25%" },
                { key: "After 3rd week", value: "No refund" }
            ]
        }
    },
    created() {
        window.scrollTo(0,0)

    },
    methods: {
        async next(){
            const isValid = await this.$refs.formModalValidate.validate();
            if (isValid){
                this.$emit('next',1)
            }
        },
    }
}
</script>
